import { Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { of } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MetadataInfo } from '../../models/metadataInfo';
import { MoovStep } from '../../models/moovStep';
import { FileDefinitionService } from '../../services/FileDefinitionService';

@Component({ standalone:false,
  selector: 'app-default-metadata-dialog',
  templateUrl: 'default-metadata-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['default-metadata-dialog.component.scss']
})
export class DefaultMetadataDialogComponent {
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  private setDataSourceAttributes() {
    if(this._dataSource){
      this._dataSource.sort = this.sort;
    }
  }

  public title: string= "Add predefined custom fields";
  public confirmButtonText = "OK";
  public cancelButtonText = "Cancel";

  private defaultMetadataProtocol?:MetadataInfo[];
  private currentMetadataInfo?:MetadataInfo[];
  private currentMoovStepArray!:MoovStep[];
  private moovStep!:MoovStep;

  private _dataSource?:MatTableDataSource<{metadataInfo:MetadataInfo, checked:boolean, nameTaken:boolean}>;
  private sort?: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<DefaultMetadataDialogComponent>, private fdService:FileDefinitionService) {
    if(data){
        this.defaultMetadataProtocol=data.defaultMetadataProtocol; //what's available
        this.currentMetadataInfo=data.currentMetadataInfo; //what the current moov step already uses
        this.currentMoovStepArray=data.currentMoovStepArray; //all current moovSteps to identify other metadata steps 
        this.moovStep = data.moovStep; //the step from which this dialog was opened
        this.setDataSource();
    }
  }

  get displayedColumns(){
    return ['checked', 'name', 'description'];
  }

  public getMetadataRuleDefinition(id:number){
    return this.fdService.getMetaDataRuleDefinitionById(id);
  }

  get dataSource(){
    return this._dataSource;
  }

  private setDataSource(){
    let takenNames = this.namesTaken();
    let valueArray:{metadataInfo:MetadataInfo, checked:boolean, nameTaken:boolean}[]=[];
    this.defaultMetadataProtocol?.forEach(dmdi=>{
      let taken = takenNames.findIndex(n=>n==dmdi.name)>-1;
      let value = {metadataInfo:dmdi, checked:taken, nameTaken:taken};
      valueArray.push(value);
    });
    this._dataSource=new MatTableDataSource(valueArray);
    this._dataSource.sort = this.sort;
  }

  private namesTaken(){
    //check which metadata names are already taken
    let namesArray:string[] = [];
    //current data first
    this.currentMetadataInfo?.forEach(mdi => namesArray.push(mdi.name));
    //only other moovsteps
    this.currentMoovStepArray?.forEach(ms=>{
        if(ms!=this.moovStep && ms.metadataInfo){
            ms.metadataInfo.forEach(mdi => namesArray.push(mdi.name));
        }
    });
    return namesArray;
}

  onConfirmClick(): void {
    //we only report the newly checked fields
    let newSelection:MetadataInfo[]=[];
    this._dataSource!.data.forEach(value=>{
      if(!value.nameTaken && value.checked) newSelection.push(value.metadataInfo);
    });
    this.dialogRef.close(newSelection);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}